import { Box, Stack, Typography } from '@mui/material';

export const SummaryValue = ({
  label,
  children,
  compact = false,
  truncate = false,
  valueAdornment = null,
}) => {
  const value = children == null || children === '' ? '--' : children;
  const valueNode = (
    <Typography
      variant="body2"
      sx={{
        ...(compact ? { fontSize: '0.72rem', lineHeight: 1.35 } : {}),
        ...(truncate
          ? { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }
          : { wordBreak: 'break-word' }),
      }}>
      {value}
    </Typography>
  );

  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant="caption"
        color="#CFCFCF"
        sx={compact ? { fontSize: '0.6rem', lineHeight: 1.3 } : undefined}>
        {label}
      </Typography>
      {valueAdornment ? (
        <Stack direction="row" alignItems="center" gap={0.5}>
          {valueNode}
          {valueAdornment}
        </Stack>
      ) : (
        valueNode
      )}
    </Box>
  );
};
